var map = {
	"./abtesting.jpeg": 204,
	"./affinitydiagramming.jpeg": 205,
	"./bullseye.jpeg": 206,
	"./businessmodelcanvas.jpeg": 207,
	"./cardsorting.jpeg": 208,
	"./churn.jpeg": 209,
	"./cocd.jpeg": 210,
	"./cognitivewalkthroughs.jpeg": 211,
	"./cojoint.jpeg": 212,
	"./conceptposter.jpeg": 213,
	"./contentanalysis.jpeg": 214,
	"./contextualinquiry.jpeg": 215,
	"./creativebrainstorm.jpeg": 216,
	"./crowdsourcing.jpeg": 217,
	"./datamining.jpeg": 218,
	"./delphi.jpeg": 219,
	"./designprobes.jpeg": 220,
	"./econometric.jpeg": 221,
	"./eeg.jpeg": 222,
	"./environmentalscan.jpeg": 223,
	"./expectancyvalue.jpeg": 224,
	"./experiencemap.jpeg": 225,
	"./experiencesampling.jpeg": 226,
	"./experiment.jpeg": 227,
	"./expertinterview.jpeg": 228,
	"./eyetracking.jpeg": 229,
	"./featuredesign.jpeg": 230,
	"./fiveforces.jpeg": 231,
	"./focusgroup.jpeg": 232,
	"./galvanicskinresponse.jpeg": 233,
	"./gamestorming.jpeg": 234,
	"./gpsbrainstormkit.jpeg": 235,
	"./habitanalysis.jpeg": 236,
	"./hackathons.jpeg": 237,
	"./heartrate.jpeg": 238,
	"./heuristicevaluation.jpeg": 239,
	"./iat.jpeg": 240,
	"./indepthinterview.jpeg": 241,
	"./innovationscales.jpeg": 242,
	"./intentionsurvey.jpeg": 243,
	"./leadusers.jpeg": 244,
	"./leanvalidationboard.jpeg": 245,
	"./legoseriousplay.jpeg": 246,
	"./logging.jpeg": 247,
	"./lotusblossom.jpeg": 248,
	"./multivariatetesting.jpeg": 249,
	"./nethnography.jpeg": 250,
	"./nonparticipatoryobservation.jpeg": 251,
	"./paperprototyping.jpeg": 252,
	"./participatoryobservation.jpeg": 253,
	"./performacemeasurement.jpeg": 254,
	"./persona.jpeg": 255,
	"./pestel.jpeg": 256,
	"./photoelicitation.jpeg": 257,
	"./pitfallescapeline.jpeg": 258,
	"./problemsolutionmatrix.jpeg": 259,
	"./psap.jpeg": 260,
	"./pta.jpeg": 261,
	"./pupildilation.jpeg": 262,
	"./qoe.jpeg": 263,
	"./qsort.jpeg": 264,
	"./scenarioanalysis.jpeg": 265,
	"./scenarioofuse.jpeg": 266,
	"./scraping.jpeg": 267,
	"./segmentationsurvey.jpeg": 268,
	"./sna.jpeg": 269,
	"./stakeholdermapping.jpeg": 270,
	"./storyboard.jpeg": 271,
	"./swot.jpeg": 272,
	"./testmarket.jpeg": 273,
	"./textualdiary.jpeg": 274,
	"./thinkingaloudprotocol.jpeg": 275,
	"./toolkitforuserinnovation.jpeg": 276,
	"./toptaskanalysis.jpeg": 277,
	"./valuechainanalyses.jpeg": 278,
	"./videodiary.jpeg": 279,
	"./willingnesstopay.jpeg": 280,
	"./wireframes.jpeg": 281,
	"./wizardofoz.jpeg": 282
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 203;